import { AbstractModel, DataModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@DataModel({
    entityName: 'com.acadiacraft.system.server.mvc.model.project.customer'
})
@JsonObject
export class FinishingVendor extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'address')
    address?: string;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'website')
    website?: string;

    @JsonProperty(Boolean, 'active')
    active?: boolean;
}